import React from "react";
import {Card, CardContent, CardHeader, Grid} from "@material-ui/core";

import QuestionForm from "../../../../component/QuestionForm/presentation/QuestionForm";
import securePage from "../../../SecurePage/SecurePage";
import ActionType from "../../../../../action/ActionType";
import {routeCustomer} from "../../../../../action/creator/router";
import retrieving from "../../../../../action/creator/asynchonous/retrieving";
import {promiseAction} from "../../../../../middleware/promiseDispatch";
import {customerClient} from "../../../../../api/relation/customer/CustomerClient";
import LoggedOn from "../../../../component/Main/Base/LoggedOn/LoggedOn";
import {Forms} from "../../../../../api/form/FormClient";
import errorAction from "../../../../../action/creator/error";
import {roles} from "../../../../../api/login/LoginClient";

const remoteError = error => {
    console.error(`${error.message}: ${error.response.message} -- ${error.response.error}`);
    return errorAction("Error adding Consumer")(error.response.message);
};

/**
 * @param {object} form
 * @return {Promise.<Action>}
 */
const addConsumerAction = form => promiseAction(customerClient.addClient(form)
                                                              .then(response => response.entity)
                                                              .then(customer => routeCustomer(customer.id)),
                                                retrieving(ActionType.asynchronous.form.post.POSTING),
                                                remoteError
);

const NewPrivateCustomer = () => (
    <LoggedOn>
        <Grid item
              lg={12}
              md={12}>
            <Card>
                <CardHeader title="Nieuwe particuliere klant"/>
                <CardContent>
                    <QuestionForm endpoint={Forms.consumerCustomer}
                                  submitAction={addConsumerAction}/>
                </CardContent>
            </Card>
        </Grid>
    </LoggedOn>
);

export default securePage([roles.admin])(NewPrivateCustomer);
